import { postToX } from './postToX';
import { xApiService } from '../services/xApiService';
import { storageService } from '../services/storageService';

/**
 * 共通のツイート投稿ハンドラ
 * API投稿時はhistoryと紐付けてトラッキングする
 */
export async function handlePostToX(
  text: string,
  toast: (msg: string, type?: 'success' | 'error' | 'warning') => void,
  t: (key: string) => string,
): Promise<void> {
  try {
    const result = await postToX(text);

    if (result.method === 'api' && result.tweetId) {
      // History内のマッチするアイテムを探してtweetIdを紐付け
      const items = storageService.getHistoryItems();
      const match = items.find(i => i.type === 'tweet' && i.content === text);
      if (match) {
        xApiService.trackPostedTweet(match.id, result.tweetId);
      } else {
        // Historyにない場合は新規追加してトラッキング
        storageService.addHistoryItem({ type: 'tweet', content: text });
        const updated = storageService.getHistoryItems();
        const newItem = updated.find(i => i.content === text);
        if (newItem) {
          xApiService.trackPostedTweet(newItem.id, result.tweetId);
        }
      }
      toast(t('common.postedToX'), 'success');
    }
    // intent URL の場合は何もしない（ブラウザが開くだけ）
  } catch (err) {
    const msg = err instanceof Error ? err.message : 'Post failed';
    toast(msg, 'error');
  }
}
